// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a687ac16","977":"670b9fab"}[chunkId] + ".chunk.js";
};